var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message"},[_c('div',{staticClass:"error-message__wrap"},[_c('i-exclamation'),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }